<!--P088、P089、P090、P091、P092、P094-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy" @click="$router.push({name:'StaffManage'})">员工管理</div>
      <div class="ui_txt_hierarchy">&nbsp;>&nbsp;</div>
      <div class="cs_font_bold cs_cursor_pointer ui_txt_hierarchy">员工详情</div>
    </div>
    <!--基本信息-->
    <div class="cs_margin_top ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">基本信息</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">工号</div>
      <div class="cs_radius_lg txt_info_search ui_margin_left_44">{{search.num}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">姓名</div>
      <input v-model="search.name" class="cs_input cs_radius_lg edtxt_info_search" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">性别</div>
      <web-select :options="SEX"
                  @option-key="updateSex"
                  v-model="search.sexName"
                  class="cs_input cs_radius_lg edtxt_info_search"></web-select>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">年龄</div>
      <input v-model="search.age" class="cs_input cs_radius_lg edtxt_info_search" placeholder="非必填">
      <button @click="btnSave" class="cs_btn cs_btn_sm ui_btn_blue cs_fr"
              type="button">保存
      </button>
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">联系方式</div>
      <input v-model="search.mobileNo" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm width_412" placeholder="非必填">
    </div>
    <!--权限信息-->
    <div class="cs_margin_top_xl ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">权限信息</div>
    </div>
    <!--角色-->
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">角色</div>
      <div class="cs_radius_lg txt_info_search width_80 ui_margin_left_72">{{roleSelectedList.length}}</div>
      <button @click="btnRole" class="cs_btn cs_btn_sm ui_btn_common cs_margin_left_sm"
              type="button">编辑
      </button>
      <div class="div_cbtn" style="top: 0;">集团管理端权限
        <span class="icon_cbtn" :class="{'on':search.isManageChecked}"></span>
        <input value="1" class="txt_cbtn" :checked='search.isManageChecked'  @click="btnManage" type="checkbox">
      </div>
      <div class="div_cbtn" style="top: 38px;">运营维护端权限
        <span class="icon_cbtn" :class="{'on':search.isOperationChecked}"></span>
        <input value="2" class="txt_cbtn" :checked='search.isOperationChecked'  @click="btnOperation" type="checkbox">
      </div>
    </div>
    <!--门店-->
    <div class="cs_margin_top_sm div_search">
      <div class="cs_title_primary cs_text_default type_info_search">所属门店</div>
      <div class="cs_radius_lg txt_info_search width_80 ui_margin_left_44">{{shopSelectedList.length}}</div>
      <button @click="btnShop" class="cs_btn cs_btn_sm ui_btn_common cs_margin_left_sm"
              type="button">编辑
      </button>
    </div>
    <!--配送中心-->
    <div class="cs_margin_top_sm div_search">
      <div class="cs_title_primary cs_text_default type_info_search">所属配送中心</div>
      <div class="cs_radius_lg txt_info_search width_80">{{dcSelectedList.length}}</div>
      <button @click="btnDc" class="cs_btn cs_btn_sm ui_btn_common cs_margin_left_sm"
              type="button">编辑
      </button>
    </div>
    <!--中央厨房-->
    <div class="cs_margin_top_sm div_search">
      <div class="cs_title_primary cs_text_default type_info_search">所属中央厨房</div>
      <div class="cs_radius_lg txt_info_search width_80">{{kitchenSelectedList.length}}</div>
      <button @click="btnKitchen" class="cs_btn cs_btn_sm ui_btn_common cs_margin_left_sm"
              type="button">编辑
      </button>
    </div>
    <!--商户-->
    <div class="cs_margin_top_sm div_search">
      <div class="cs_title_primary cs_text_default type_info_search">所属商户</div>
      <div class="cs_radius_lg txt_info_search width_80 ui_margin_left_44">{{merchantSelectedList.length}}</div>
      <button @click="btnMerchant" class="cs_btn cs_btn_sm ui_btn_common cs_margin_left_sm"
              type="button">编辑
      </button>
    </div>

    <!--状态信息-->
    <div class="cs_margin_top_xl ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">状态信息</div>
    </div>
    <!--状态-->
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">状态</div>
      <div class="cs_radius_lg txt_info_search width_128">{{STAFF_STATUS[search.isStop]}}</div>
      <button v-show="!search.isStop" @click="btnStop" class="cs_btn cs_btn_sm ui_btn_common cs_margin_left_sm"
              type="button">注销
      </button>
      <button v-show="search.isStop" @click="btnStart" class="cs_btn cs_btn_sm ui_btn_common cs_margin_left_sm"
              type="button">启用
      </button>
    </div>
    <div class="div_bottom"></div>

    <!--角色弹窗，默认显示-->
    <div v-if="isDialogRoleShow" class="ui_div_dialog cs_scrollable_vertical">
      <div class="ui_dialog_container" style="width:482px;height:622px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">编辑角色</div>
        </div>
        <div class="cs_margin_top_lg div_table">
          <table class="cs_table cs_thead_fixed cs_td_divider_none" width="100%">
            <thead>
            <tr>
              <th width="44px">序号</th>
              <th width="100%">角色</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in roleList" :class="{ 'table_tr_selected': item.isSelected}" @click="btnSelectTableTrRoleDialog(item)">
              <td width="44px">{{index+1}}</td>
              <td width="100%">{{item.roleName}}</td>
            </tr>
            <template v-if="PAGE_SIZE>roleList.length">
              <tr v-for="(item,index) in (PAGE_SIZE-roleList.length)">
                <td width="40px"></td>
                <td width="100%"></td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <!--确定取消按钮-->
        <div class="cs_margin_top div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogRole">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmRoleDialog">确定</button>
        </div>
      </div>
    </div>
    <!--门店弹窗，默认显示-->
    <div v-if="isDialogShopShow" class="ui_div_dialog cs_scrollable_vertical">
      <div class="ui_dialog_container" style="width:542px;height:622px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">编辑所属门店</div>
        </div>
        <div class="cs_margin_top_lg div_table">
          <table class="cs_table cs_thead_fixed cs_td_divider_none" width="100%">
            <thead>
            <tr>
              <th width="44px">序号</th>
              <th width="128px">门店编号</th>
              <th width="100%">门店名称</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in shopList" :class="{ 'table_tr_selected': item.isSelected}" @click="btnSelectTableTrShopDialog(item)">
              <td width="44px">{{index+1}}</td>
              <td width="128px">{{item.shopNum}}</td>
              <td width="100%">{{item.shopName}}</td>
            </tr>
            <template v-if="PAGE_SIZE>shopList.length">
              <tr v-for="(item,index) in (PAGE_SIZE-shopList.length)">
                <td width="40px"></td>
                <td width="128px"></td>
                <td width="100%"></td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <!--确定取消按钮-->
        <div class="cs_margin_top div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogShop">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmShopDialog">确定</button>
        </div>
      </div>
    </div>
    <!--配送中心弹窗，默认显示-->
    <div v-if="isDialogDcShow" class="ui_div_dialog cs_scrollable_vertical">
      <div class="ui_dialog_container" style="width:542px;height:622px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">编辑所属配送中心</div>
        </div>
        <div class="cs_margin_top_lg div_table">
          <table class="cs_table cs_thead_fixed cs_td_divider_none" width="100%">
            <thead>
            <tr>
              <th width="44px">序号</th>
              <th width="128px">配送中心编号</th>
              <th width="100%">配送中心名称</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in dcList" :class="{ 'table_tr_selected': item.isSelected}" @click="btnSelectTableTrDcDialog(item)">
              <td width="44px">{{index+1}}</td>
              <td width="128px">{{item.dcNum}}</td>
              <td width="100%">{{item.dcName}}</td>
            </tr>
            <template v-if="PAGE_SIZE>dcList.length">
              <tr v-for="(item,index) in (PAGE_SIZE-dcList.length)">
                <td width="40px"></td>
                <td width="128px"></td>
                <td width="100%"></td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <!--确定取消按钮-->
        <div class="cs_margin_top div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogDc">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmDcDialog">确定</button>
        </div>
      </div>
    </div>
    <!--中央厨房弹窗，默认显示-->
    <div v-if="isDialogKitchenShow" class="ui_div_dialog cs_scrollable_vertical">
      <div class="ui_dialog_container" style="width:542px;height:622px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">编辑所属中央厨房</div>
        </div>
        <div class="cs_margin_top_lg div_table">
          <table class="cs_table cs_thead_fixed cs_td_divider_none" width="100%">
            <thead>
            <tr>
              <th width="44px">序号</th>
              <th width="128px">中央厨房编号</th>
              <th width="100%">中央厨房名称</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in kitchenList" :class="{ 'table_tr_selected': item.isSelected}" @click="btnSelectTableTrKitchenDialog(item)">
              <td width="44px">{{index+1}}</td>
              <td width="128px">{{item.kitchenNum}}</td>
              <td width="100%">{{item.kitchenName}}</td>
            </tr>
            <template v-if="PAGE_SIZE>kitchenList.length">
              <tr v-for="(item,index) in (PAGE_SIZE-kitchenList.length)">
                <td width="40px"></td>
                <td width="128px"></td>
                <td width="100%"></td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <!--确定取消按钮-->
        <div class="cs_margin_top div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogKitchen">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmKitchenDialog">确定</button>
        </div>
      </div>
    </div>
    <!--商户弹窗，默认显示-->
    <div v-if="isDialogMerchantShow" class="ui_div_dialog cs_scrollable_vertical">
      <div class="ui_dialog_container" style="width:542px;height:622px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">编辑所属商户</div>
        </div>
        <div class="cs_margin_top_lg div_table">
          <table class="cs_table cs_thead_fixed cs_td_divider_none" width="100%">
            <thead>
            <tr>
              <th width="44px">序号</th>
              <th width="128px">商户编号</th>
              <th width="100%">商户名称</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in merchantList" :class="{ 'table_tr_selected': item.isSelected}" @click="btnSelectTableTrMerchantDialog(item)">
              <td width="44px">{{index+1}}</td>
              <td width="128px">{{item.merchantNum}}</td>
              <td width="100%">{{item.merchantName}}</td>
            </tr>
            <template v-if="PAGE_SIZE>merchantList.length">
              <tr v-for="(item,index) in (PAGE_SIZE-merchantList.length)">
                <td width="40px"></td>
                <td width="128px"></td>
                <td width="100%"></td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <!--确定取消按钮-->
        <div class="cs_margin_top div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogMerchant">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmMerchantDialog">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import SearchSelect from "../../components/search-select"
  import {SEX,STAFF_STATUS,PAGE_SIZE} from "../../assets/utils/constants"
  import WhParameter from "../../assets/csui/parameter/WhParameter"
  export default {
    name: "StaffDetail",
    components: {WebSelect,SearchSelect},
    data: function () {
      return {
        search: {
          num: "",
          name: "",
          sexId: "",
          sexName: "",
          age: "",
          mobileNo: "",
          isStop: "",
          isManageChecked: false,
          isOperationChecked: false,
        },
        isDialogRoleShow: false,
        roleList: [],
        roleSelectedList: [],
        isDialogShopShow: false,
        shopList: [],
        shopSelectedList: [],
        isDialogDcShow: false,
        dcList: [],
        dcSelectedList: [],
        isDialogKitchenShow: false,
        kitchenList: [],
        kitchenSelectedList: [],
        isDialogMerchantShow: false,
        merchantList: [],
        merchantSelectedList: [],
        SEX: SEX,
        STAFF_STATUS: STAFF_STATUS,
        PAGE_SIZE: PAGE_SIZE
      }
    },
    created: function () {
      this.showDetail();
    },
    mounted: function() {
    },
    methods: {
      showDetail(){
        this.$ajax.staff.acquire.bind(this)(this.$route.query.num,(data) => {
          this.search.num = data.data.staffNum;
          this.search.name = data.data.staffName;
          this.search.sexId = data.data.staffSex;
          this.search.sexName = SEX[data.data.staffSex];
          this.search.mobileNo = data.data.staffMobileno;
          this.search.age = data.data.staffAge;
          this.search.isStop = data.data.isStop;
          this.roleSelectedList = data.data.roleIdList;
          this.shopSelectedList = data.data.shopIds;
          this.dcSelectedList = data.data.dcIds;
          this.kitchenSelectedList = data.data.kitchenIds;
          this.merchantSelectedList = data.data.merchantIds;
          this.search.isOperationChecked = data.data.hasOperation;
          this.search.isManageChecked = data.data.hasManage;
        }, (data) => {
        }, true)
      },
      btnSave(){
        try {
          WhParameter.verifyNotEmpty(this.search.name, "姓名");
        }catch (e) {
          this.$toast(e.message);
          return;
        }
        if(this.isEmptySelect(this.search.sexId)){
          this.$toast("请选择性别");
          return;
        }
        this.$ajax.staff.modify.bind(this)(this.search,(data) => {
          this.$toast("保存成功");
          this.showDetail();
        }, (data) => {
        }, true)
      },
      updateSex(key) {
        this.search.sexId = key;
      },

      //角色
      btnRole(){
        this.$ajax.role.listRole.bind(this)((data) => {
          let list = data.data;
          if(this.roleSelectedList.length<1){
            list.forEach((item) => {
              item.isSelected = false;
            });
          }else {
            list.forEach((item) => {
              item.isSelected = this.isInArray(this.roleSelectedList, item.id);
            });
          }
          this.roleList = list;
          this.isDialogRoleShow = true;
        }, (data) => {
        }, true);
      },
      btnSelectTableTrRoleDialog(item){
        let selectedStatus = item.isSelected;
        item.isSelected = !selectedStatus;
      },
      closeDialogRole(){
        this.roleList = [];
        this.roleSelectedList = [];
        this.isDialogRoleShow = false;
        this.showDetail();
      },
      btnConfirmRoleDialog(){
        let roleIds= "";
        this.roleList.forEach((item) => {
          if(item.isSelected){
            roleIds += item.id + ",";
          }
        });
        this.$ajax.staff.addRole.bind(this)(this.$route.query.num,roleIds, (data) => {
          this.roleList = [];
          this.roleSelectedList = [];
          this.isDialogRoleShow = false;
          this.showDetail();
        }, (data) => {
        }, true);
      },
      //门店
      btnShop(){
        this.$ajax.common.listShop.bind(this)((data) => {
          let list = data.data;
          if(this.shopSelectedList.length<1){
            list.forEach((item) => {
              item.isSelected = false;
            });
          }else {
            list.forEach((item) => {
              item.isSelected = this.isInArray(this.shopSelectedList, item.id);
            });
          }
          this.shopList = list;
          this.isDialogShopShow = true;
        }, (data) => {
        }, true);
      },
      btnSelectTableTrShopDialog(item){
        let selectedStatus = item.isSelected;
        item.isSelected = !selectedStatus;
      },
      closeDialogShop(){
        this.shopList = [];
        this.shopSelectedList = [];
        this.isDialogShopShow = false;
        this.showDetail();
      },
      btnConfirmShopDialog(){
        let shopIds= "";
        this.shopList.forEach((item) => {
          if(item.isSelected){
            shopIds += item.id + ",";
          }
        });
        this.$ajax.staff.addModule.bind(this)(this.$route.query.num,"SHOP",shopIds, (data) => {
          this.shopList = [];
          this.shopSelectedList = [];
          this.isDialogShopShow = false;
          this.showDetail();
        }, (data) => {
        }, true);
      },
      //配送中心
      btnDc(){
        this.$ajax.common.listDistributionCenter.bind(this)((data) => {
          let list = data.data;
          if(this.dcSelectedList.length<1){
            list.forEach((item) => {
              item.isSelected = false;
            });
          }else {
            list.forEach((item) => {
              item.isSelected = this.isInArray(this.dcSelectedList, item.id);
            });
          }
          this.dcList = list;
          this.isDialogDcShow = true;
        }, (data) => {
        }, true);
      },
      btnSelectTableTrDcDialog(item){
        let selectedStatus = item.isSelected;
        item.isSelected = !selectedStatus;
      },
      closeDialogDc(){
        this.dcList = [];
        this.dcSelectedList = [];
        this.isDialogDcShow = false;
        this.showDetail();
      },
      btnConfirmDcDialog(){
        let dcIds= "";
        this.dcList.forEach((item) => {
          if(item.isSelected){
            dcIds += item.id + ",";
          }
        });
        this.$ajax.staff.addModule.bind(this)(this.$route.query.num,"DISTRIBUTION",dcIds, (data) => {
          this.dcList = [];
          this.dcSelectedList = [];
          this.isDialogDcShow = false;
          this.showDetail();
        }, (data) => {
        }, true);
      },
      //中央厨房
      btnKitchen(){
        this.$ajax.common.listKitchen.bind(this)((data) => {
          let list = data.data;
          if(this.kitchenSelectedList.length<1){
            list.forEach((item) => {
              item.isSelected = false;
            });
          }else {
            list.forEach((item) => {
              item.isSelected = this.isInArray(this.kitchenSelectedList, item.id);
            });
          }
          this.kitchenList = list;
          this.isDialogKitchenShow = true;
        }, (data) => {
        }, true);
      },
      btnSelectTableTrKitchenDialog(item){
        let selectedStatus = item.isSelected;
        item.isSelected = !selectedStatus;
      },
      closeDialogKitchen(){
        this.kitchenList = [];
        this.kitchenSelectedList = [];
        this.isDialogKitchenShow = false;
        this.showDetail();
      },
      btnConfirmKitchenDialog(){
        let kitchenIds= "";
        this.kitchenList.forEach((item) => {
          if(item.isSelected){
            kitchenIds += item.id + ",";
          }
        });
        this.$ajax.staff.addModule.bind(this)(this.$route.query.num,"KITCHEN",kitchenIds, (data) => {
          this.kitchenList = [];
          this.kitchenSelectedList = [];
          this.isDialogKitchenShow = false;
          this.showDetail();
        }, (data) => {
        }, true);
      },
      //商户
      btnMerchant(){
        this.$ajax.common.listMerchant.bind(this)((data) => {
          let list = data.data;
          if(this.merchantSelectedList.length<1){
            list.forEach((item) => {
              item.isSelected = false;
            });
          }else {
            list.forEach((item) => {
              item.isSelected = this.isInArray(this.merchantSelectedList, item.id);
            });
          }
          this.merchantList = list;
          this.isDialogMerchantShow = true;
        }, (data) => {
        }, true);
      },
      btnSelectTableTrMerchantDialog(item){
        let selectedStatus = item.isSelected;
        item.isSelected = !selectedStatus;
      },
      closeDialogMerchant(){
        this.merchantList = [];
        this.merchantSelectedList = [];
        this.isDialogMerchantShow = false;
        this.showDetail();
      },
      btnConfirmMerchantDialog(){
        let merchantIds= "";
        this.merchantList.forEach((item) => {
          if(item.isSelected){
            merchantIds += item.id + ",";
          }
        });
        this.$ajax.staff.addModule.bind(this)(this.$route.query.num,"MERCHANT",merchantIds, (data) => {
          this.merchantList = [];
          this.merchantSelectedList = [];
          this.isDialogMerchantShow = false;
          this.showDetail();
        }, (data) => {
        }, true);
      },
      //状态
      btnStop(){
        this.$ajax.staff.stop.bind(this)(this.$route.query.num, true,(data) => {
          this.$toast("注销成功");
          this.showDetail();
        }, (data) => {
        }, true);
      },
      btnStart(){
        this.$ajax.staff.stop.bind(this)(this.$route.query.num, false,(data) => {
          this.$toast("启用成功");
          this.showDetail();
        }, (data) => {
        }, true);
      },

      //管理端权限
      btnManage() {
        this.search.isManageChecked = !this.search.isManageChecked;
        let selected = this.search.isManageChecked?0:"";
        this.$ajax.staff.addModule.bind(this)(this.$route.query.num,"MANAGE",selected, (data) => {
          this.showDetail();
        }, (data) => {
        }, true);
      },
      //运维端权限
      btnOperation() {
        this.search.isOperationChecked = !this.search.isOperationChecked;
        let selected = this.search.isOperationChecked?0:"";
        this.$ajax.staff.addModule.bind(this)(this.$route.query.num,"OPERATION",selected, (data) => {
          this.showDetail();
        }, (data) => {
        }, true);
      },

      failDefault() {
      },
      isInArray(arr,value){
        return arr.some((item)=>{
          if(item===value){
            return true;
          }
        })
      }
    },
  }
</script>

<style scoped>
  .width_412{width: 412px;}
  .width_80{width: 80px;}
  .width_128{width: 128px;}
  .div_cbtn{
    position: absolute;
    left: 412px;
    height: 22px;
    line-height: 22px;
    font-size: 14px;
    color: #485465;
    z-index: 10;
  }
  .txt_cbtn {
    position: absolute;
    display: inline-block;
    top: 0;
    left: 108px;
    opacity: 0;
    width: 78px;
    height: 22px;
    cursor: pointer;
    outline: none;
    -webkit-appearance: none;
  }
  .icon_cbtn {
    position: absolute;
    display: inline-block;
    top: 0;
    left: 108px;
    width: 78px;
    height: 22px;
    cursor: pointer;
    background: url(../../assets/image/icon_cbtn_off.png) no-repeat center;
    background-size: 78px 22px;
  }
  .on {
    background: url(../../assets/image/icon_cbtn_on.png) no-repeat center;
    background-size: 78px 22px;
  }
  .cs_table tbody{max-height: 411px;}
</style>



// WEBPACK FOOTER //
// src/page/staff/StaffDetail.vue